export default __webpack_public_path__ + "static/media/DESTINATION.22b936d9.svg";